import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

export function trackBannersShow(sc: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп',
        trapid: 'Баннер загородки десктоп',
        source,
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackBannerKpLinkClick(sc: IJsonQuery, source?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (КП)',
        trapid: 'Баннер загородки десктоп (КП)',
        source,
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackTrapKpLinkClick(sc: IJsonQuery, source?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (Ловушка КП)',
        trapid: 'Баннер загородки десктоп (Ловушка КП)',
        source,
      },
    },
    sc,
    useLastProducts: true,
  });
}

export function trackBannerBuildersClick(sc: IJsonQuery, source?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер загородки десктоп (Построить дом)',
        trapid: 'Баннер загородки десктоп (Построить дом)',
        source,
      },
    },
    sc,
    useLastProducts: true,
  });
}
